import { Accordion } from '@/types';
import React from 'react';
import AccordionsComponent from '@components/Accordions';

type Props = {
  accordions: Accordion[];
  blocktitle?: string;
};

function createUrlString(value: string) {
  value = value.toLowerCase();
  value = value.replace(/ä/g, 'ae');
  value = value.replace(/ö/g, 'oe');
  value = value.replace(/ü/g, 'ue');
  value = value.replace(/ß/g, 'ss');
  value = value.replace(/ /g, '');
  value = value.replace(/\./g, '');
  value = value.replace(/,/g, '');
  value = value.replace(/\(/g, '');
  value = value.replace(/\)/g, '');
  return value;
}

const Accordions = (props: Props) => {
  const { accordions, blocktitle } = props;

  return (
    <div
      className="streamfield accordions"
      id={createUrlString(blocktitle || 'accordion')}
    >
      {blocktitle ? <h2 className="accordions__header">{blocktitle}</h2> : ''}

      <AccordionsComponent className="" accordions={accordions} />
    </div>
  );
};

export default Accordions;
